import { View } from "react-native";
import { QuestionnaireSubmitForm } from "../../forms/QuestionnaireForm";
import { QuestionnaireAnswer, QuestionnaireStepQuestion, QuestionnaireSubmitForm as QuestionnaireStepData } from "app/_modules/core/questionnaire";
import { IStepComponentProps } from "@shared/components/form/types";

export interface IQuestionnaireSubmitStepContext {
  question: QuestionnaireStepQuestion;
  answer?: QuestionnaireAnswer;
  showError?: boolean;
  onAnswerChange: (questionId: string, answer: QuestionnaireAnswer) => void;
}

export const QuestionnaireSubmitStep = ({ context }: IStepComponentProps<QuestionnaireStepData, IQuestionnaireSubmitStepContext>) => {
    if (!context) {
      return <View className="flex-1" />;
    }

    return (
        <View className="flex-1">
           <QuestionnaireSubmitForm
              question={context.question}
              answer={context.answer}
              showError={context.showError}
              onAnswerChange={(answer) => context.onAnswerChange(context.question.id, answer)}
            />
        </View>
    )
}
